import { useCallback, useEffect, useState } from 'react'

import { BREAKPOINTS } from '@mc/media'

import { responsiveValues } from './helpers'

const getSizes = () => {
  const width = typeof window !== 'undefined' ? window.innerWidth : 0

  return {
    isXS: width < BREAKPOINTS.SM,
    gteXS: width >= BREAKPOINTS.XS,

    isSM: width >= BREAKPOINTS.SM && width < BREAKPOINTS.MD,
    ltSM: width < BREAKPOINTS.SM,
    gteSM: width >= BREAKPOINTS.SM,

    isMD: width >= BREAKPOINTS.MD && width < BREAKPOINTS.LG,
    ltMD: width < BREAKPOINTS.MD,
    gteMD: width >= BREAKPOINTS.MD,

    isLG: width >= BREAKPOINTS.LG && width < BREAKPOINTS.XL,
    ltLG: width < BREAKPOINTS.LG,
    gteLG: width >= BREAKPOINTS.LG,

    isXL: width >= BREAKPOINTS.XL,
    ltXL: width < BREAKPOINTS.XL,
    gteXL: width >= BREAKPOINTS.XL,
  }
}

const useResponsiveHandler = () => {
  const [isMounted, setIsMounted] = useState(false)
  const [sizes, setSizes] = useState(getSizes)

  const calculateSizes = useCallback(() => {
    setSizes(getSizes())
  }, [])

  useEffect(() => {
    window.addEventListener('resize', calculateSizes)

    setIsMounted(true)
    calculateSizes()

    return () => {
      window.removeEventListener('resize', calculateSizes)
    }
  }, [calculateSizes, setIsMounted])

  const handleHelper = useCallback(
    <T>(xs?: T, s?: T, m?: T, l?: T, xl?: T) =>
      responsiveValues(sizes, xl, l, m, s, xs),
    [sizes],
  )

  return { isMounted, ...sizes, responsive: handleHelper }
}

export default useResponsiveHandler
